module.exports = __webpack_public_path__ + "img/svg/result-winner-trophy.d0998d83daa00ad0b8531e02355617ca.svg";